<template>
  <div class="animated fadeIn">
    <b-row>
      <b-col cols="12" xl="6">
        <b-card :header="$t('Subtype')" style="position:relative">
          <b-form @submit.prevent="onSubmitDetails" autocomplete="off" ref="det">
            <FloatingLabel v-model="details.name" label="Name" autocomplete="false" size="sm" />
            <FloatingLabel
              v-model="details.observation"
              label="Observation"
              autocomplete="false"
              type="textarea"
              size="sm"
            />

            <div style="text-align:right">
              <b-dropdown variant="success" right split :text="$t('Save')" @click="onSubmitDetails">
                <b-dropdown-item @click="saveAsNew">{{$t('Save As New')}}</b-dropdown-item>
              </b-dropdown>
            </div>
          </b-form>
        </b-card>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import Multiselect from "@/components/multiselect-filters";
import FloatingLabel from "@/components/FloatingLabel";
import { successConf, errorConf } from "@/shared/notifications";

export default {
  name: "subtype",
  props: ["selectedeid"],
  components: {
    Multiselect,
    FloatingLabel
  },
  mounted() {
    this.eid = this.$route.params.id != "0" ? this.$route.params.id : "";

    if (this.selectedeid) {
      this.eid = this.selectedeid;
    } else if (!this.eid) {
      this.eid = "";
    }

    if (this.eid != "0" && this.eid != "") {
      this.loadData();
    } else {
      this.newId = true;
    }
  },
  data: function() {
    return {
      eid: "",
      details: {
        name: "",
        observation: ""
      },
      newId: false,

      temp: {}
    };
  },
  methods: {
    loadData() {
      if (this.eid == "") {
        // new role; nothing to load
        return;
      }
      const loadDet = this.$loading.open({
        container: this.$refs.det
      });

      this.$store
        .dispatch("subtype/read", this.eid)
        .then(resp => {
          this.temp = resp.data;
          this.populateData(resp.data);
        })
        .catch(err => {
          this.showErrorNotification(err);
        })
        .finally(() => {
          loadDet.close();
        });
    },
    saveAsNew() {
      this.eid = "";
      this.newId = true;
      this.onSubmitDetails();
    },
    onSubmitDetails() {
      const loadDet = this.$loading.open({
        container: this.$refs.det
      });

      const detailsData = JSON.parse(JSON.stringify(this.details));
      let apiAction = "subtype/update";
      if (this.newId) {
        apiAction = "subtype/create";
      } else {
        detailsData.eid = this.eid;
      }

      this.$store
        .dispatch(apiAction, detailsData)
        .then(resp => {
          let msg = "Subtype updated";
          if (this.newId && resp.data.id) {
            this.updateBankId(resp.data.id);
            msg = "Subtype created";
          }
          this.showSuccessNotification(msg);
        })
        .catch(err => {
          this.showErrorNotification(err);
        })
        .finally(() => {
          loadDet.close();
        });
    },
    populateData(r) {
      if (typeof r == "undefined") return;
      this.eid = typeof r.eid != "undefined" ? r.eid : "";
      this.details.name = r.name;
      this.details.observation = r.observation;
    },
    updateBankId(id) {
      this.eid = id;
      this.newId = false;
      this.$router.replace({ name: "Subtype", params: { id: id } });
    },
    showErrorNotification(err) {
      if (err.details && err.details.length) {
        this.$bvToast.toast(
          this.$t(err.details[0]),
          errorConf(this.$t("Error"))
        );
      } else {
        this.$bvToast.toast(this.$t(err.message), errorConf(this.$t("Error")));
      }
    },
    showSuccessNotification(msg) {
      this.$bvToast.toast(this.$t(msg), successConf(this.$t("Success")));
    }
  }
};
</script>

<style lang="scss" scoped>
</style>
